import { defineMessages } from 'react-intl';

/**
 * Stable copy of the jö Bonus Club overview presentation.
 *
 * These IDs are deliberately separate from the checkout-only `JoeLoyalty` messages:
 * the wording differs and the checkout component must not be refactored for this feature.
 */
export const joeMessages = defineMessages({
  cardHeadline: {
    id: 'Joe.Overview.CardHeadline',
    defaultMessage: 'jö Bonus Club',
  },
  alreadyCustomerHeadline: {
    id: 'Joe.Overview.Disconnected.Headline',
    defaultMessage: 'Sind Sie bereits Kunde bei jö?',
  },
  connectInvitation: {
    id: 'Joe.Overview.Disconnected.Invitation',
    defaultMessage: 'Jetzt Ihr Konto verknüpfen, Ös sammeln und viel Geld sparen.',
  },
  connectButton: {
    id: 'Joe.Overview.Disconnected.ConnectButton',
    defaultMessage: 'Konto verknüpfen',
  },
  dataProtection: {
    id: 'Joe.Overview.Disconnected.DataProtection',
    defaultMessage:
      'Durch das Verknüpfen der jö Karte mit {companyName} stimmen Sie zu, dass Ihre Daten mit jö geteilt werden. Weitere Informationen finden Sie in unseren <link>Datenschutzbestimmungen</link>.',
  },
  registerQuestion: {
    id: 'Joe.Overview.Disconnected.RegisterQuestion',
    defaultMessage: 'Noch kein jö Mitglied?',
  },
  registerLink: {
    id: 'Joe.Overview.Disconnected.RegisterLink',
    defaultMessage: 'Jetzt registrieren',
  },
  benefitsHeadline: {
    id: 'Joe.Overview.Disconnected.BenefitsHeadline',
    defaultMessage: 'jö Vorteile im Überblick',
  },
  benefitCollect: {
    id: 'Joe.Overview.Disconnected.BenefitCollect',
    defaultMessage: 'Bei jedem Einkauf Ös sammeln: <b>Pro 2€ erhalten Sie ein Ö</b>',
  },
  benefitActionCodes: {
    id: 'Joe.Overview.Disconnected.BenefitActionCodes',
    defaultMessage: 'Durch die Eingabe von Aktionscodes mehrfach Ös erhalten.',
  },
  connectedMessage: {
    id: 'Joe.Overview.Connected.Message',
    defaultMessage:
      'Ihr {companyName}-Konto ist mit Ihrem jö Konto verknüpft. Sie sammeln bei jedem Einkauf Ös.',
  },
  disconnectButton: {
    id: 'Joe.Overview.Connected.DisconnectButton',
    defaultMessage: 'Konto trennen',
  },
  statusError: {
    id: 'Joe.Overview.StatusError',
    defaultMessage:
      'Der jö Bonus Club ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
  },
  connectError: {
    id: 'Joe.Overview.Connect.Error',
    defaultMessage: 'Beim Verknüpfen Ihres jö Kontos ist ein Fehler aufgetreten.',
  },
  connectSuccess: {
    id: 'Joe.Overview.Connect.Success',
    defaultMessage: 'Ihr Konto wurde erfolgreich verknüpft.',
  },
  disconnectSuccess: {
    id: 'Joe.Overview.Disconnect.Success',
    defaultMessage: 'Ihr Konto wurde erfolgreich getrennt.',
  },
  disconnectError: {
    id: 'Joe.Overview.Disconnect.Error',
    defaultMessage: 'Beim Trennen Ihres jö Kontos ist ein Fehler aufgetreten.',
  },
});
